import CreneauHeureFin from '@/generated/controls/creneau/CreneauHeureFin.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: CreneauHeureFin
})